import styles from "./join.module.css";
import { Button, Input, Popconfirm, message } from "antd";
import {
  SmileTwoTone,
  PlayCircleTwoTone,
  LogoutOutlined,
  DeleteFilled,
} from "@ant-design/icons";
import Create from "../Create/create";
import { useState, useEffect, useContext } from "react";
import { db } from "../utils/firebase";
import { onValue, ref, update, set } from "firebase/database";
import { LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { MyContext } from "../utils/utils";
const Join = ({}) => {
  const { currentUser } = useContext(MyContext);
  const [rooms, setRooms] = useState(null);
  const [joinRooms, setJoinRooms] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    onValue(ref(db, "rooms"), (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setRooms(data);
      } else {
        setRooms(null);
      }
    });

    if (currentUser) {
      onValue(ref(db, "users/" + currentUser.uid), (snapshot) => {
        const val = snapshot.val();
        if (val) {
          setJoinRooms(Object.keys(val));
        } else {
          setJoinRooms([]);
        }
      });
    }
  }, [db, currentUser]);
  const [showInput, setShowInput] = useState(null);

  const onJoin = (key, value) => {
    if (!showInput) setShowInput(key);
    const password = document.getElementById("password" + key).value;
    if (value.password == password) {
      const joinerRef = ref(db, "rooms/" + key + "/joiner/" + currentUser.uid);
      const userInfo = {
        name: currentUser.displayName,
        middleJoin: true,
      };
      update(joinerRef, userInfo);

      const userRef = ref(db, "users/" + currentUser.uid + "/" + key);
      set(userRef, "joiner");

      setShowInput(null);
      const url = "/game/" + key;
      navigate(url);
    }
  };

  const onExit = (key) => {
    const userRef = ref(db, "users/" + currentUser.uid + "/" + key);
    const joinerRef = ref(db, "rooms/" + key + "/joiner/" + currentUser.uid);
    set(userRef, null);
    set(joinerRef, null);

    message.info("방에서 나왔습니다");
  };

  const onDelete = (key) => {
    onValue(
      ref(db, "rooms/" + key + "/joiner"),
      (snapshot) => {
        const val = snapshot.val();

        for (var uid in val) {
          const userRef = ref(db, "users/" + uid + "/" + key);
          set(userRef, null);
        }
      },
      {
        onlyOnce: true,
      }
    );

    const gameRef = ref(db, "rooms/" + key);
    set(gameRef, null);
  };

  const joinAgain = (key) => {
    const url = "/game/" + key;
    navigate(url);
  };
  return (
    <div className={styles.panel}>
      {joinRooms.length > 0 && (
        <>
          <div className={styles.title}>참여중</div>
          <div className={styles.roomBoxs}>
            {joinRooms.map((key) => {
              const value = rooms[key];
              return (
                <div className={styles.roomBox}>
                  <div className={styles.flex}>
                    {value.state == "OPEN" ? (
                      <SmileTwoTone style={{ fontSize: "x-large" }} />
                    ) : (
                      <PlayCircleTwoTone style={{ fontSize: "x-large" }} />
                    )}
                    <p className={styles.roomState}>{value.state}</p>
                  </div>
                  <p className={styles.roomName}>{value.name}</p>

                  <Button shape="round" onClick={() => joinAgain(key)}>
                    재입장하기
                  </Button>
                  <div
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Popconfirm
                      placement="bottom"
                      title="정말 방에서 나갈 건가요?"
                      okText="네"
                      cancelText="취소"
                      onConfirm={() => onExit(key)}
                    >
                      <Button
                        shape="round"
                        type="link"
                        icon={<LogoutOutlined />}
                        danger
                      >
                        나가기
                      </Button>
                    </Popconfirm>
                    <Popconfirm
                      placement="bottom"
                      title="정말 게임을 종료할 건가요?"
                      okText="네"
                      cancelText="취소"
                      onConfirm={() => onDelete(key)}
                    >
                      <Button
                        shape="round"
                        type="link"
                        icon={<DeleteFilled />}
                        danger
                      >
                        종료하기
                      </Button>
                    </Popconfirm>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}

      <div className={styles.titleBox}>
        <div className={styles.title}>참여하기</div>
        <Create />
      </div>
      <div className={styles.rooms}>
        {rooms ? (
          Object.keys(rooms).map((key, _) => {
            const value = rooms[key];
            if (joinRooms.includes(key)) return null;
            return (
              <div className={styles.roomBox}>
                <div className={styles.flex}>
                  {value.state == "OPEN" ? (
                    <SmileTwoTone style={{ fontSize: "x-large" }} />
                  ) : (
                    <PlayCircleTwoTone style={{ fontSize: "x-large" }} />
                  )}
                  <p className={styles.roomState}>{value.state}</p>
                </div>
                <p className={styles.roomName}>{value.name}</p>

                <Input
                  id={"password" + key}
                  prefix={<LockOutlined />}
                  placeholder="비밀번호"
                  style={{ width: "60%", marginRight: "10px" }}
                />
                <Button shape="round" onClick={() => onJoin(key, value)}>
                  참여하기
                </Button>
              </div>
            );
          })
        ) : (
          <div className={styles.noroom}>
            <img src={"/icons/empty.png"} width="80px" />
            <p>아직 방이 없습니다</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Join;
